import { Box, Link, List, ListItem, useMediaQuery } from '@mui/material'
import Grid from '@mui/material/Grid'
import Paper from '@mui/material/Paper'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import { useEffect, useState } from 'react'
import { AccordionComponent } from '../../components/Accordion/Accordion'
import { Footer } from '../../components/Footer/Footer'
import AppForm from '../../components/Form/AppForm/AppForm'
import AppInput from '../../components/Form/AppInput/AppInput'
import { ErrorMessage } from '../../components/ErrorMessage/ErrorMessage'
import { ProgressBar } from '../../components/ProgressBar/ProgressBar'
import { container } from '../../global'
import { appTheme } from '../../theme'
import { useStyles } from './style'
import { makeStyles } from '@mui/styles'
import { useNavigate, useParams } from 'react-router-dom'
import {
  createEvent,
  updateEventInfo,
  eventDetail
} from '../../services/EventService'
import InfoIcon from '../../images/infoIcon.svg'
import moment from 'moment'
import { ApprovalStatus, EventType, Role } from '../../services/Types'
import { Editor } from '../../components/Editor/Editor'
import { EventValidationProvider, useEventValidation } from '../../contexts/EventValidationContext'
var isWebView = true
var isMobView = true
const Item = styled(Paper)(({ theme }) =>
  isWebView
    ? { padding: theme.spacing(0, 6, 3, 6) }
    : { padding: theme.spacing(0, 4, 3, 4) }
)

let user: any = localStorage.getItem('user')
if (user) user = JSON.parse(user)

const addStyle = makeStyles({
  root: {
    height: 'calc(100vh - 72px)',
    overflow: 'auto',
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: ' rgba(0, 0, 0, 0.2)'
      },
      '&:hover fieldset': {
        borderColor: '#006BD7'
      },
      '&.Mui-focused fieldset': {
        borderColor: '#006BD7'
      }
    }
  }
})

const titleValidator = (title: string) => {
  if (!title || title === '') {
    return 'Please enter event title'
  }
  if (title.length > 100) {
    return 'Title must be less than 100 characters'
  }
  return ''
}

const summaryValidator = (summary: string) => {
  if (!summary || summary === '') {
    return 'Please enter event summary'
  }
  if (summary.length > 500) {
    return 'Summary must be less than 500 characters'
  }
  return ''
}

const descriptionValidator = (description: string) => {
  return ''
}

// Wrapper component to access validation context for Footer
const FooterWrapper: React.FC<{
  saveExit: () => void;
  nextClick: () => void;
  backClick: () => void;
  activePageTitle: string;
  canMoveNext: boolean;
  disbledSave: boolean;
}> = ({ saveExit, nextClick, backClick, activePageTitle, canMoveNext, disbledSave }) => {
  const { hasEventValidationErrors } = useEventValidation();
  
  return (
    <Footer
      saveExit={saveExit}
      nextClick={nextClick}
      backClick={backClick}
      activePageTitle={activePageTitle}
      canMoveNext={canMoveNext && !hasEventValidationErrors()}
      disbledSave={disbledSave || hasEventValidationErrors()}
    />
  );
};

export default function EventInfoPage() {
  const classes = useStyles()
  const className = addStyle()
  isWebView = !useMediaQuery(appTheme.breakpoints.down('lg'))
  isMobView = useMediaQuery(appTheme.breakpoints.down('lg'))
  const [showServerError, setShowServerError] = useState(false)
  const [serverError, setServerError] = useState('')

  const navigate = useNavigate()
  const [titleError, setTitleError] = useState('')
  const [summaryError, setSummaryError] = useState('')
  const [descriptionError, setDescriptionError] = useState('')
  const [titleInstruction, setTitleInstruction] = useState('')
  // const { updateEvent } = useAuthState()
  const [eventData, setEvent] = useState<any>({
    id: 0,
    title: '',
    summary: '',
    description: '',
    eventType: ''
  })
  let { id } = useParams()

  const handleChange = (event: any) => {
    let name = event.target.name
    let value = event.target.value

    setEvent({ ...eventData, [name]: value })

    name === 'title' && setTitleError(titleValidator(event.target.value))
    name === 'summary' && setSummaryError(summaryValidator(event.target.value))
    name === 'description' &&
      setDescriptionError(descriptionValidator(event.target.value))
  }

  const validateEventInfo = (pData?: any) => {
    let l_eventData = pData || eventData
    let validate = true
    if (titleValidator(l_eventData.title) !== '') {
      validate = false
      setTitleError(titleValidator(l_eventData.title))
    }
    if (summaryValidator(l_eventData.summary) !== '') {
      validate = false
      setSummaryError(summaryValidator(l_eventData.summary))
    }
    if (descriptionValidator(l_eventData.description) !== '') {
      validate = false
      setDescriptionError(descriptionValidator(l_eventData.description))
    }
    return validate
  }

  const validateTitle = () => {
    let validate = true
    if (titleValidator(eventData.title) !== '') {
      validate = false
      setTitleError(titleValidator(eventData.title))
    }
    return validate
  }

  const [titleValidated, setValidateTitle] = useState(false)
  useEffect(() => {
    if (titleValidator(eventData.title) !== '') {
      setValidateTitle(false)
    } else setValidateTitle(true)
  }, [eventData.title])

  useEffect(() => {
    showServerError &&
      setTimeout(() => {
        setShowServerError(false)
      }, 5000)
  }, [showServerError])

  const displayServerError = () => {
    setShowServerError(true)
    setServerError('Internal server error')
  }

  const loadEventData = async () => {
    try {
      // if(id === undefined || id === null){
      //   await loadEventWithoutDate()
      // }
      const { data } = await eventDetail(Number(id))
      if (data) {
        let eventData = data.eventDetail.data
        if (eventData === null) {
          return navigate('/')
        }
        if (eventData.creater.id !== user.id && user.role !== Role.ADMIN) {
          return navigate('/')
        }
        if (eventData.status.startsWith('APPROVAL') && user.role !== Role.ADMIN) {
          return navigate('/')
        }
        let liveRoomBooking = eventData.roomBooking?.find((x: any) => x.category === 'live')
        if (
          liveRoomBooking &&
          Number(liveRoomBooking.date) < moment.utc().set({ h: 0, m: 0, s: 0, ms: 0 }).valueOf() &&
          user.role !== Role.ADMIN
        ) {
          return navigate('/')
        }
        setEvent(eventData)
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (user.approvalStatus !== ApprovalStatus.APPROVED) {
      return navigate('/')
    }

    if (id !== undefined && id !== null) {
      loadEventData()
    }

    if (
      localStorage.getItem('eventType') !== undefined &&
      localStorage.getItem('eventType') !== null
    ) {
      setEvent({ ...eventData, eventType: localStorage.getItem('eventType') })
      localStorage.removeItem('eventType')
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const isSeries = eventData.eventType === EventType.SERIES
    const titleInstruction = isSeries ?
      'Provide a general title, summary and description that reflects the theme of your series/convening.'
      : 'Please provide a title, summary, and description of your event.'

    setTitleInstruction(titleInstruction)
  }, [eventData.eventType])

  const nextClick = async () => {
    if (!validateEventInfo()) {
      return
    }

    if (eventData.id) {
      try {
        const results = await updateEventInfo(
          eventData.id,
          eventData.title,
          eventData.summary,
          eventData.description
        )
        const { data } = results
        if (data) {
          if (data.updateEvent.statusCode === 200) {
            navigate('/event/staff/' + eventData.id)
          } else {
            displayServerError()
          }
        } else {
          displayServerError()
        }
      } catch (error) {
        displayServerError()
      }
    } else {
      try {
        const results = await createEvent(
          eventData.title,
          eventData.summary,
          eventData.description,
          eventData.eventType
        )
        const { data } = results
        if (data) {
          if (data.createEvent.statusCode === 200) {
            localStorage.setItem(
              'eventData',
              JSON.stringify(data.createEvent.data)
            )
            navigate('/event/staff/' + data.createEvent.data.id)
          } else {
            displayServerError()
          }
        } else {
          displayServerError()
        }
      } catch (error) {
        displayServerError()
      }
    }
  }

  const saveExit = async () => {
    if (!validateTitle()) return navigate('/')
    else {
      if (eventData.id) {
        try {
          const results = await updateEventInfo(
            eventData.id,
            eventData.title,
            eventData.summary,
            eventData.description
          )
          const { data } = results
          if (data) {
            if (data.updateEvent.statusCode === 200) {
              navigate('/')
            } else {
              console.log(data.createEvent.message)
              displayServerError()
            }
          } else {
            console.log('Server error')
            displayServerError()
          }
        } catch (error) {
          console.log(error)
          displayServerError()
        }
      } else {
        try {
          const results = await createEvent(
            eventData.title,
            eventData.summary,
            eventData.description,
            eventData.eventType
          )
          const { data } = results
          if (data) {
            if (data.createEvent.statusCode === 200) {
              navigate('/')
            } else {
              console.log(data.createEvent.message)
              displayServerError()
            }
          } else {
            console.log('Server error')
            displayServerError()
          }
        } catch (error) {
          console.log(error)
          displayServerError()
        }
      }
    }
  }

  const backClick = async () => {
    if (id !== undefined && id !== null) {
      navigate('/event/requestingType/' + id)
    } else {
      navigate('/event/requestingType')
    }
  }

  return (
    <EventValidationProvider>
      <Box className={className.root}>
      <ProgressBar
        activePageTitle='Event Info'
        requestType={eventData.eventType}
      />
      <Item sx={{ bgcolor: 'rgba(0, 0, 0, 0.02)' }}>
        <Box style={container}>
          <Grid container sx={{ pt: '70px' }}>
            {showServerError && (
              <Grid item xs={12} sm={12} md={12}>
                <ErrorMessage
                  message={serverError}
                  justifyContent='center'
                  icon={true}
                />
              </Grid>
            )}

            <Grid item sm={12} md={6}>
              <Box
                sx={{
                  my: { sm: '25px' },
                  pb: '5px',
                  width: { lg: '85%', md: '85%' },
                  borderBottom: '1px solid rgba(0, 0, 0, 0.2)'
                }}
              >
                <Typography
                  align='left'
                  sx={{
                    mb: 0.5,
                    ml: { sm: '25px', xs: '0px' },
                    fontSize: '24px',
                    lineHeight: '32px',
                    color: '#565656'
                  }}
                >
                  Tips for a great event
                </Typography>
              </Box>

              <div className={classes.accordianContainer}>
                <Grid item sm={6} md={12}>
                  <Box className={classes.accordian} sx={{ mb: 2 }}>
                    <AccordionComponent
                      title='Title, Summary, & Description'
                      summary={
                        <List
                          sx={{
                            textAlign: 'left',
                            listStyleType: 'number',
                            pl: 2,
                            '& .MuiListItem-root': {
                              display: 'list-item'
                            }
                          }}
                        >
                          <ListItem
                            sx={{ display: 'list-item', paddingBottom: '0px' }}
                          >
                            <Box sx={{ display: 'inline' }}>
                              <Typography sx={{ display: 'inline' }}>
                                The{' '}
                              </Typography>
                              <Typography
                                sx={{ fontWeight: 'bold', display: 'inline' }}
                              >
                                Title{' '}
                              </Typography>
                              <Typography sx={{ display: 'inline' }}>
                                {' '}
                                will be the first thing your prospective
                                audience sees and so should be descriptive and
                                specific.  Avoid acronyms if possible. There is
                                a 100-character limit on the length of your
                                title.
                              </Typography>
                            </Box>
                          </ListItem>
                          <ListItem
                            sx={{ display: 'list-item', paddingBottom: '0px' }}
                          >
                            <Box sx={{ display: 'inline' }}>
                              <Typography sx={{ display: 'inline' }}>
                                The{' '}
                              </Typography>
                              <Typography
                                sx={{ fontWeight: 'bold', display: 'inline' }}
                              >
                                Summary{' '}
                              </Typography>
                              <Typography sx={{ display: 'inline' }}>
                                {' '}
                                is used to create your Event Invitation so make
                                it engaging and informative.  Tell your audience
                                what they will get out of your event, and why
                                they should attend. There is a 500-character
                                limit (including spaces) on the length of your
                                Summary.
                              </Typography>
                            </Box>
                          </ListItem>
                          <ListItem
                            sx={{ display: 'list-item', paddingBottom: '0px' }}
                          >
                            <Box sx={{ display: 'inline' }}>
                              <Typography sx={{ display: 'inline' }}>
                                The{' '}
                              </Typography>
                              <Typography
                                sx={{ fontWeight: 'bold', display: 'inline' }}
                              >
                                Description{' '}
                              </Typography>
                              <Typography sx={{ display: 'inline' }}>
                                {' '}
                                is an optional field, but highly recommended as
                                the place where you can add additional
                                information and details about your event that
                                does not fit in the Summary field. Use it to
                                provide more context for your event, past
                                project efforts, historical background, or
                                agency requirements, among other things. There
                                is a 2500-character limit (including spaces) on
                                the length of your title.
                              </Typography>
                            </Box>
                          </ListItem>
                        </List>
                      }
                      panel='panel1'
                    />
                  </Box>
                  <Box className={classes.accordian} sx={{ mt: 2, mb: 2 }}>
                    <AccordionComponent
                      title='Avoid Acronyms'
                      summary={
                        <List
                          sx={{
                            textAlign: 'left',
                            listStyleType: 'disc',
                            pl: 2,
                            '& .MuiListItem-root': {
                              display: 'list-item'
                            }
                          }}
                        >
                          <ListItem
                            sx={{ display: 'list-item', paddingBottom: '0px' }}
                          >
                            <Typography sx={{ display: 'inline' }}>
                              Avoid acronyms in your Title. If your Title has
                              acronyms, spell them out, if possible, given
                              100-character limit. If you can only spell out
                              parts of an acronym, pick the parts that will most
                              help the reader quickly grasp the content (e.g.,
                              the title, "USDOL Study on I-BEST" – spell out
                              “I-BEST” instead of “USDOL” since more people will
                              be familiar with USDOL than I-BEST.)
                            </Typography>
                          </ListItem>
                          <ListItem
                            sx={{ display: 'list-item', paddingBottom: '0px' }}
                          >
                            <Typography sx={{ display: 'inline' }}>
                              You should also make sure to spell out acronyms
                              the first time you use them in the Summary and
                              Description so everyone understands what is being
                              referenced.  Adding this information will also
                              help people searching for your event and will
                              expedite the review/approval process for your
                              event.
                            </Typography>
                          </ListItem>
                        </List>
                      }
                      panel='panel2'
                    />
                  </Box>
                </Grid>
                <Grid item sm={6} md={12}>
                  <Box className={classes.accordian} sx={{ mb: 2 }}>
                    <AccordionComponent
                      title='Best Practices'
                      summary={
                        <List
                          sx={{
                            textAlign: 'left',
                            listStyleType: 'disc',
                            pl: 2,
                            '& .MuiListItem-root': {
                              display: 'list-item'
                            }
                          }}
                        >
                          <ListItem
                            sx={{ display: 'list-item', paddingBottom: '0px' }}
                          >
                            Titles, Summaries and Descriptions should be written
                            from a marketing perspective. The first sentences
                            should say what your audience will get if they take
                            the trouble to participate in your event.  Make your
                            Title, Summary, and Description lively and appealing
                            so that more people will sign up for your event.
                          </ListItem>
                          <ListItem
                            sx={{ display: 'list-item', paddingBottom: '0px' }}
                          >
                            Never begin your Summary or Description with "This
                            resource is..." It's better to use short,
                            bullet-like statements such as "Describes the 10
                            promising practices of XYZ."
                          </ListItem>
                          <ListItem
                            sx={{ display: 'list-item', paddingBottom: '0px' }}
                          >
                            Never start with "ETA (or whomever) developed this
                            resource on this date..."  Instead, lead with a
                            plain language description of what this product
                            provides, and why you want your audience to attend.
                          </ListItem>
                          <ListItem
                            sx={{ display: 'list-item', paddingBottom: '0px' }}
                          >
                            <Typography sx={{ display: 'inline' }}>
                              You might also find the 
                            </Typography>
                            <Link
                              href='https://tahelp.workforcegps.org/resources/2020/04/14/15/06/WorkforceGPS-Style-Guide'
                              sx={{
                                display: 'inline',
                                fontWeight: 'bold',
                                color: '#006BD7'
                              }}
                            >
                              WorkforceGPS Style Guide
                            </Link>
                            <Typography sx={{ display: 'inline' }}>
                              {' '}
                              to be a useful resource when developing your event
                              information.
                            </Typography>
                          </ListItem>
                        </List>
                      }
                      panel='panel3'
                    />
                  </Box>
                  {/* <Box className={classes.accordian} sx={{mt:2, mb:2}}>
                    <AccordionComponent
                      title="ETA Style Guide"
                      summary=" Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        Suspendisse malesuada lacus ex, sit amet blandit leo lobortis
                        eget."
                      panel="panel4"
                    />
                  </Box> */}
                </Grid>
              </div>
            </Grid>

            <Grid item xs={12} sm={12} md={6} sx={{ mb: '64px' }}>
              <Box
                sx={{
                  p: { lg: '32px', md: '32px' },
                  background: { lg: '#FFFFFF', md: '#FFFFFF' },
                  borderRadius: '24px',
                  marginBottom: '80px'
                }}
              >
                {!isMobView && (
                  <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                    <Box
                      sx={{
                        width: '40px',
                        height: '40px',
                        borderRadius: '8px',
                        padding: '8px',
                        background: 'rgba(0, 107, 215, 0.1)'
                      }}
                    >
                      <Box component='img' src={InfoIcon} alt='Info Icon' />
                    </Box>
                    <Typography
                      sx={{
                        ml: '10px',
                        fontSize: { lg: '32px', md: '32px' },
                        fontWeight: '700',
                        lineHeight: '37.5px'
                      }}
                    >
                      Event Info
                    </Typography>
                  </Box>
                )}

                <Typography
                  align='left'
                  variant='body1'
                  sx={{ ml: { sm: 1, md: 1 }, mt: 1 }}
                >
                  {titleInstruction}
                </Typography>

                <AppForm onFormChange={() => null}>
                  <Box className={classes.textField}>
                    <AppInput
                      field='title'
                      name='title'
                      label='Title'
                      required
                      size='small'
                      multiline
                      minRows={1}
                      maxRows={2}
                      placeholder='Enter Title'
                      onChangeCapture={handleChange}
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      value={eventData.title}
                      error={!!titleError}
                      inputProps={{ maxLength: 100 }}
                      sx={{
                        '.MuiOutlinedInput-root': { px: 0, py: 1 },
                        textarea: { pl: 1.5, pr: 0.5 },
                        ...(!!titleError && {
                          '.MuiOutlinedInput-root.Mui-focused': {
                            fieldset: { borderColor: '#D50000' }
                          }
                        }),
                        '.MuiOutlinedInput-root.Mui-focused': {
                          fieldset: { borderColor: '#006BD7' }
                        }
                      }}
                    />
                  </Box>
                  <Box className={classes.textField}>
                    <AppInput
                      field='summary'
                      name='summary'
                      label='Summary'
                      required
                      multiline
                      size='small'
                      rows={5}
                      placeholder='Enter Summary'
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      value={eventData.summary}
                      onChangeCapture={handleChange}
                      error={!!summaryError}
                      inputProps={{ maxLength: 500 }}
                      sx={{
                        '.MuiOutlinedInput-root': { px: 0, py: 1 },
                        textarea: { pl: 1.5, pr: 0.5 },
                        ...(!!summaryError && {
                          '.MuiOutlinedInput-root.Mui-focused': {
                            fieldset: { borderColor: '#D50000' }
                          }
                        })
                      }}
                    />
                  </Box>

                  <Box className={classes.textField}>
                    <label>Description</label>
                    <Editor
                      setEditorText={(text: string) => {
                        const syntheticEvent = {target: {value: text, name: 'description'}} as React.ChangeEvent<HTMLInputElement>;
                        handleChange(syntheticEvent);
                      }}
                      validationField="description"
                      style={{ borderRadius: '8px', padding: '8px' }}
                      editorText={eventData?.description}
                      placeholder='Enter Description'
                      maxLength={2500}
                    />
                  </Box>
                </AppForm>
              </Box>
            </Grid>
          </Grid>
          <FooterWrapper
            saveExit={saveExit}
            nextClick={nextClick}
            backClick={backClick}
            activePageTitle='Event Info'
            canMoveNext={true}
            disbledSave={!titleValidated}
          />
        </Box>
      </Item>
      </Box>
    </EventValidationProvider>
  )
}
